module.exports = __webpack_public_path__ + "static/media/logo.cbd58ced.png";